(function () {
  'use strict';

  var endpoint =
    'https://restock.highaltitudecosmeceuticals.us/subscribe.php';

  var botLoader;

  function loadBotCheck() {
    if (window.turnstile) return Promise.resolve();

    if (!botLoader) {
      botLoader = new Promise(function (resolve, reject) {
        window.hacRestockBotReady = resolve;

        var script = document.createElement('script');
        script.src =
          'https://challenges.cloudflare.com/turnstile/v0/api.js' +
          '?render=explicit&onload=hacRestockBotReady';

        script.async = true;

        script.onerror = function () {
          botLoader = null;
          reject(new Error('Bot check could not load.'));
        };

        document.head.appendChild(script);
      });
    }

    return botLoader;
  }

  function init() {
    document.querySelectorAll('.hac-restock').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';

      var variants = JSON.parse(
        box.querySelector('.hac-restock__variants').textContent
      );

      var container =
        document.getElementById('ProductSection-' + box.dataset.section) ||
        box.closest('[data-section-id]') ||
        box.parentElement;

      var fields = box.querySelector('.hac-restock__fields');
      var toggle = box.querySelector('.hac-restock__toggle');
      var email = box.querySelector('.hac-restock__email');
      var send = box.querySelector('.hac-restock__send');
      var status = box.querySelector('.hac-restock__status');

      var selected;
      var token = '';
      var widget;
      var rendering = false;
      var busy = false;
      var signupConfirmed = false;

      function setStatus(message, success) {
        status.textContent = message;

        status.classList.toggle(
          'hac-restock__status--success',
          success === true
        );

        status.style.setProperty(
          'color',
          success === true ? '#28743b' : '#a63a2b',
          'important'
        );
      }

      function updateButton() {
        send.disabled =
          busy || !token || !selected || selected.available;
      }

      function resetBot() {
        token = '';

        if (widget !== undefined && window.turnstile) {
          window.turnstile.reset(widget);
        }

        updateButton();
      }

      function update(v) {
        var changed =
          String(selected && selected.id) !== String(v && v.id);

        selected = v;
        box.hidden = !v || v.available;

        box.querySelector('.hac-restock__size').textContent =
          v && v.title !== 'Default Title' ? v.title : 'this item';

        if (changed) {
          signupConfirmed = false;
          setStatus('', false);
          resetBot();
        }

        updateButton();
      }

      async function showBot() {
        if (widget !== undefined || rendering) return;

        rendering = true;
        setStatus('Loading bot check…', false);

        try {
          await loadBotCheck();

          widget = window.turnstile.render(
            box.querySelector('.hac-restock__bot'),
            {
              sitekey: box.dataset.sitekey,
              action: 'restock',
              'response-field': false,

              callback: function (value) {
                token = value;

                if (status.textContent === 'Loading bot check…') {
                  setStatus('', false);
                }

                updateButton();
              },

              'expired-callback': function () {
                token = '';
                updateButton();
              },

              'error-callback': function () {
                token = '';

                if (!signupConfirmed) {
                  setStatus(
                    'Bot check unavailable. Please refresh and try again.',
                    false
                  );
                }

                updateButton();
              }
            }
          );
        } catch (error) {
          if (!signupConfirmed) {
            setStatus(
              'Bot check could not load. Close and reopen this form to retry.',
              false
            );
          }
        } finally {
          rendering = false;
        }
      }

      update(variants.find(function (v) {
        return String(v.id) === box.dataset.variant;
      }));

      if (window.jQuery) {
        window.jQuery(container).on(
          'variantChange.hacRestock',
          function (event) {
            update(event.variant);
          }
        );
      }

      container.addEventListener('change', function (event) {
        if (!event.target.matches(
          '.single-option-selector, select[name="id"]'
        )) return;

        var options = Array.from(
          container.querySelectorAll('.single-option-selector')
        ).map(function (input) {
          return input.value;
        });

        var v = variants.find(function (variant) {
          if (!options.length) {
            return String(variant.id) === event.target.value;
          }

          return variant.options.length === options.length &&
            variant.options.every(function (option, index) {
              return option === options[index];
            });
        });

        update(v);
      });

      toggle.addEventListener('click', function () {
        fields.hidden = !fields.hidden;
        toggle.setAttribute('aria-expanded', String(!fields.hidden));

        if (!fields.hidden) {
          email.focus();
          showBot();
        }
      });

      email.addEventListener('input', function () {
        signupConfirmed = false;
        setStatus('', false);
      });

      email.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();

          if (!send.disabled) {
            send.click();
          }
        }
      });

      send.addEventListener('click', async function () {
        if (busy || !token || !selected || selected.available) return;

        if (!email.value.trim() || !email.checkValidity()) {
          signupConfirmed = false;
          setStatus('Please enter a valid email address.', false);
          email.reportValidity();
          return;
        }

        var submittedId = String(selected.id);
        var submittedEmail = email.value.trim();

        signupConfirmed = false;
        busy = true;
        updateButton();
        setStatus('Saving your request…', false);

        var controller = new AbortController();

        var timeout = setTimeout(function () {
          controller.abort();
        }, 45000);

        function sameRequest() {
          return selected &&
            String(selected.id) === submittedId &&
            email.value.trim() === submittedEmail;
        }

        try {
          var response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json'
            },
            signal: controller.signal,
            body: JSON.stringify({
              email: submittedEmail,
              handle: box.dataset.handle,
              variant: submittedId,
              turnstile_token: token,
              website: box.querySelector('.hac-restock__trap').value
            })
          });

          var result = await response.json();

          if (sameRequest()) {
            var message =
              result.message || 'Please try again shortly.';

            var newSignup =
              response.ok &&
              result.ok === true &&
              message ===
                'We will email you when this option is back in stock.';

            var alreadyRegistered =
              response.ok &&
              result.ok === true &&
              message ===
                'You are already on the notification list for this option.';

            signupConfirmed = newSignup || alreadyRegistered;

            setStatus(message, newSignup);
          }
        } catch (error) {
          if (sameRequest()) {
            signupConfirmed = false;

            setStatus(
              'Unable to confirm your request. Please try again.',
              false
            );
          }
        } finally {
          clearTimeout(timeout);
          busy = false;
          resetBot();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();